import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import IndexIndecator from "../../IndexIndicator/IndexIndecator";
import OccasionsOverall from "./occassionsAndNeedsComponents/OccasionsOverall";
import FilterByForDashboard from "../FilterByForDashboard";
import { useGlobalContext } from "../../../context/GlobalContext";
import {
  getOccasionsChartData,
  getNeedsChartData,
  getNeedsCompareOccasionChartData,
} from "../../../services/dashboard/needsAndOccasions";
import {
  COMMON_PAGE_BOTTOM_TEXT,
  INDEX_SCORE_INDICATOR,
  SURVEY_BASE_SIZE_MID_VALUE,
  SURVEY_BASE_SIZE_MIN_VALUE,
} from "../../../utils/constants";
import NeedsOverall from "./occassionsAndNeedsComponents/NeedsOverall";
import NeedsCompareOccasion from "./occassionsAndNeedsComponents/NeedsCompareOccasion";
import { validateCompareObjectValues } from "../../../utils/filterBy/filterBy";

const OccasionsAndNeeds = (props) => {
  const {
    productType = "",
    selectedFilters,
    setSelectedFilters,
    isFilterByApplied,
    setIsFilterByApplied,
    selectedFilterValues,
    setSelectedFilterValues,
    compareBy,
  } = props;
  const {
    device,
    deviceCode,
    category,
    product_id,
    showSidebar,
    mappedCategory,
    project_id,
  } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [activeOption, setActiveOption] = useState("FILTERBY");
  const { token, user } = useSelector((state) => state.auth);
  const { question_id } = useSelector(
    (state) => state.dashboard.occasionsListData,
  );
  const { filter_week } = useSelector((state) => state.dateRange);
  const { hideFilter: isFilterHide } = useSelector((state) => state.dashboard);
  // const [selectedFilters, setSelectedFilters] = useState({});
  const [occasionsTableData, setOccasionsTableData] = useState({});
  const [occasionQuestion, setOccasionQuestion] = useState("");
  const [needsTableData, setNeedsTableData] = useState({});
  const [needQuestion, setNeedQuestion] = useState("");
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedHouseHoldAge, setSelectedHouseHoldAge] = useState([]);
  const [selectedHouseHoldIncome, setSelectedHouseHoldIncome] = useState([]);
  const [selectedHouseHoldSize, setSelectedHouseHoldSize] = useState([]);
  const [selectedHouseHoldChildren, setSelectedHouseHoldChildren] = useState(
    [],
  );
  const [selectedHouseHoldRaceEthnicity, setSelectedHouseHoldRaceEthnicity] =
    useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const [selectedDayPart, setSelectedDayPart] = useState([]);
  const [selectedWeekPart, setSelectedWeekPart] = useState([]);
  const [selectedTimeOfDay, setSelectedTimeOfDay] = useState([]);
  const [filterByApply, setFilterByApply] = useState(false);
  // const [isFilterHide, setIsFilterHide] = useState(false);

  const onlyCompareByHaveKey1 = useMemo(() => {
    if (!compareBy) return false;

    return (
      compareBy.key_1?.value !== "" &&
      Object.keys(compareBy)
        .filter((key) => key !== "key_1")
        .every((key) => compareBy[key]?.value === "")
    );
  }, [compareBy]);

  const getSelectedCategoriesString = () => {
    const categories = [];
    if (selectedHouseHoldAge.length > 0) categories.push("age");
    if (selectedHouseHoldIncome.length > 0) categories.push("income");
    if (selectedHouseHoldSize.length > 0) categories.push("size");
    if (selectedHouseHoldChildren.length > 0) categories.push("children");
    if (selectedHouseHoldRaceEthnicity.length > 0)
      categories.push("raceEthnicity");
    return categories.join("|");
  };

  useEffect(() => {
    if (productType !== "" && question_id !== "") {
      fetchOccasionsData();
      fetchNeedsData();
      // fetchNeedsCompareOccasionData();
    }
  }, [productType, question_id, filterByApply, props?.apply, filter_week]);

  const getRequestBody = () => {
    return {
      compare_with: props?.selectedComparitionBy,
      compare_by: props?.compareBy,
      filter_form:
        props?.selectedComparitionBy !== "form" || activeOption === "FILTERBY"
          ? selectedForms.join("|")
          : "",
      filter_brand:
        props?.selectedComparitionBy !== "brand" || activeOption === "FILTERBY"
          ? selectedBrands.join("|")
          : "",
      filter_household: isFilterByApplied
        ? selectedFilterValues?.houseHold
          ? Object.values(selectedFilterValues?.houseHold)
              .flat()
              .map((item) => item.uniques.trim())
              .filter((value) => value !== "All") // Remove "All" if present
              .join("|")
          : ""
        : "",
      filter_household_type:
        activeOption === "FILTERBY" ? getSelectedCategoriesString() : "",
      product_id: parseInt(product_id),
      product_type: productType,
      project_id: parseInt(project_id),
      mapped_category: mappedCategory,
      filter_week: filter_week,
    };
  };

  const fetchOccasionsData = () => {
    setLoading(true);
    const requestBody = {
      ...getRequestBody(),
      filter_gender:
        activeOption === "FILTERBY" ? selectedGenders.join("|") : "",
      question_id: question_id !== "" ? parseInt(question_id) : 0,
      section_type:
        props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
          ? "compare"
          : "filter",
    };

    getOccasionsChartData(requestBody, token)
      .then((occasionsChartDataResponse) => {
        setOccasionsTableData(occasionsChartDataResponse?.data?.graphs);
        setOccasionQuestion(occasionsChartDataResponse?.data?.question);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchNeedsData = () => {
    setLoading(true);
    const requestBody = {
      ...getRequestBody(),
      filter_occasion:
        activeOption === "FILTERBY" ? selectedOccasions.join("|") : "",
      occasion_question_id: question_id !== null ? parseInt(question_id) : "",
      section_type:
        props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
          ? "compare"
          : "filter",
    };
    getNeedsChartData(requestBody, token)
      .then((needsChartDataResponse) => {
        setNeedsTableData(needsChartDataResponse?.data?.graphs);
        setNeedQuestion(needsChartDataResponse?.data?.question);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const fetchNeedsCompareOccasionData = () => {
  //     setLoading(true);
  //     const requestBody = {
  //         ...getRequestBody(),
  //         compare_with: '',
  //         compare_by: {},
  //         filter_occasion: activeOption === "FILTERBY" ? selectedOccasions.join("|") : "",
  //         occasion_question_id: parseInt(question_id),
  //         section_type: "filter"
  //     };

  //     getNeedsCompareOccasionChartData(requestBody, token).then((needsCmpOccasionChartDataResponse) => {
  //         setNeedsCmpOccasionTableData(needsCmpOccasionChartDataResponse?.data?.graphs);
  //         setNeedsCmpOccasionQuestion(needsCmpOccasionChartDataResponse?.data?.question);
  //     }).catch((error) => {
  //         console.error("Error fetching chart data:", error);
  //     }).finally(() => {
  //         setLoading(false);
  //     });
  // };

  useEffect(() => {
    if (props?.selectedComparitionBy === "brand") {
      setSelectedBrands([]);
    }
    if (props?.selectedComparitionBy === "form") {
      setSelectedForms([]);
    }
    if (props?.selectedComparitionBy === "household") {
      setSelectedFilters({});
    }
  }, [props?.selectedComparitionBy]);

  useEffect(() => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    // setSelectedFilters({});
    setSelectedForms([]);
  }, [parseInt(product_id)]);

  const handleReset = () => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedFilters({});
    setSelectedForms([]);
    setFilterByApply(!filterByApply);
    setIsFilterByApplied(false);
    setSelectedFilterValues({});
  };

  const handleFilterApply = () => {
    setSelectedFilterValues((prevProp) => {
      return {
        ...prevProp,
        houseHold: selectedFilters,
      };
    });
  };

  return (
    <div className="row tab-container">
      {/* {user?.type === "superadmin" ? ( */}
      <FilterByForDashboard
        loading={loading}
        setLoading={setLoading}
        device={device}
        deviceCode={deviceCode}
        category={category}
        product_id={product_id}
        productType={productType}
        activeOption={activeOption}
        setActiveOption={setActiveOption}
        occasion={true}
        selectedForms={selectedForms}
        setSelectedForms={setSelectedForms}
        selectedBrands={selectedBrands}
        setSelectedBrands={setSelectedBrands}
        selectedGenders={selectedGenders}
        setSelectedGenders={setSelectedGenders}
        selectedOccasions={selectedOccasions}
        setSelectedOccasions={setSelectedOccasions}
        selectedHouseHoldAge={selectedHouseHoldAge}
        setSelectedHouseHoldAge={setSelectedHouseHoldAge}
        selectedHouseHoldIncome={selectedHouseHoldIncome}
        setSelectedHouseHoldIncome={setSelectedHouseHoldIncome}
        selectedHouseHoldSize={selectedHouseHoldSize}
        setSelectedHouseHoldSize={setSelectedHouseHoldSize}
        selectedHouseHoldChildren={selectedHouseHoldChildren}
        setSelectedHouseHoldChildren={setSelectedHouseHoldChildren}
        selectedHouseHoldRaceEthnicity={selectedHouseHoldRaceEthnicity}
        setSelectedHouseHoldRaceEthnicity={setSelectedHouseHoldRaceEthnicity}
        selectedDayPart={selectedDayPart}
        setSelectedDayPart={setSelectedDayPart}
        selectedWeekPart={selectedWeekPart}
        setSelectedWeekPart={setSelectedWeekPart}
        selectedTimeOfDay={selectedTimeOfDay}
        setSelectedTimeOfDay={setSelectedTimeOfDay}
        apply={filterByApply}
        setApply={(filterByflagValue) => {
          setFilterByApply(filterByflagValue);
          setIsFilterByApplied(true);
          handleFilterApply();
        }}
        isCompareByClicked={props?.isCompareByClicked}
        setIsCompareByClicked={props?.setIsCompareByClicked}
        setSelectedFilters={setSelectedFilters}
        selectedFilters={selectedFilters}
        handleReset={handleReset}
        // setIsFilterHide={(toggle) => setIsFilterHide(toggle)}
        selectedComparitionBy={props?.selectedComparitionBy}
        mappedCategory={mappedCategory}
      />
      {/* ) : (
        ""
      )} */}
      <div
        className={isFilterHide ? `col-12` : `col-9`}
        style={{ padding: "0px 3%" }}
      >
        <IndexIndecator
          greenTextValue={INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE}
          greyTextValue={`${INDEX_SCORE_INDICATOR.GREY_TEXT_MIN_VALUE}-${INDEX_SCORE_INDICATOR.GREY_TEXT_MAX_VALUE}`}
          redTextValue={INDEX_SCORE_INDICATOR.RED_TEXT_VALUE}
        />
        <div className="pt-4">
          <OccasionsOverall
            occasionsTableData={occasionsTableData}
            occasionQuestion={occasionQuestion}
            loading={loading}
            hideShowIndex={onlyCompareByHaveKey1}
          />
          <NeedsOverall
            needsTableData={needsTableData}
            needQuestion={needQuestion}
            loading={loading}
            hideShowIndex={onlyCompareByHaveKey1}
          />
          {/* <NeedsCompareOccasion
                        needsCmpOccasion={needsCmpOccasionTableData}
                        needCmpOccasionQuestion={needsCmpOccasionQuestion}
                        loading={loading}
                    />  */}
        </div>

        {!loading ? (
          <div
            className="text-light-gray text-start my-3"
            style={{
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {/* {COMMON_PAGE_BOTTOM_TEXT} */}
            <div>{`*Low sample (n<${SURVEY_BASE_SIZE_MIN_VALUE} survey responses)`}</div>
            <div>{`^Directional Use Only (n=${SURVEY_BASE_SIZE_MID_VALUE} survey responses)`}</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default OccasionsAndNeeds;
